import React from 'react';
import PropTypes from 'prop-types';
import ImportMainDivisionList from './c/importMainDivisionList/ImportMainDivisionList';
import SubGroupsMenu from './c/subGroupsMenu/SubGroupsMenu';
import './mapColumns.scss';
import ColumnListsSlidingPanel from './c/columnListsSlidingPanel/ColumnListsSlidingPanelConnector';
import TranslationTableMenu from './c/translationTableMenu/TranslationTableMenuConnector';

class MapColumns extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleDivisionSelect = index => this.props.mappingActions.setActiveDivision(index);

  handleNoSubgroupCallback = () => {
    const { acceptedFiles, filesActions: { getFileMappingInfo }, delimiter } = this.props;
    getFileMappingInfo({
      files: acceptedFiles,
      additionalInformation: {identifierPosition: 1, identifiers: [''], delimiter },
      url: 'utm/v1/source-file/columns'
    });
  };

  handleApplyLabels = (identifierPosition, identifiers) => {
    const { acceptedFiles, filesActions: { getFileMappingInfo }, delimiter } = this.props;
    getFileMappingInfo({
      files: acceptedFiles,
      additionalInformation: {identifierPosition, identifiers, delimiter },
      url: 'utm/v1/source-file/columns'
    });
  };

  render() {
    const { activeDivision, divisions, fileExtension } = this.props;
    return (
      <div className="map-columns__main-container">
        <div className="map-columns__side-container">
          <h3>Input Data</h3>
          <ImportMainDivisionList divisions={ divisions } selectedDivision={ activeDivision } onDivisionSelect={ this.handleDivisionSelect } />
        </div>
        <div>
          <SubGroupsMenu onNoSubGroupClick={ this.handleNoSubgroupCallback } onApplyLabels={ this.handleApplyLabels } fileExtension={ fileExtension } />
          <TranslationTableMenu currentDivision={ divisions[activeDivision] } />
          <ColumnListsSlidingPanel currentDivision={ divisions[activeDivision] } />
        </div>
      </div>
    );
  }
}

MapColumns.propTypes = {
  fileExtension: PropTypes.string.isRequired,
  activeDivision: PropTypes.number.isRequired,
  divisions: PropTypes.arrayOf(PropTypes.string).isRequired,
  delimiter: PropTypes.string,
  acceptedFiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCloseParentSlide: PropTypes.func,
  onForcedCloseParentSlide: PropTypes.func,
  filesActions: PropTypes.shape({
    getFileMappingInfo: PropTypes.func
  }).isRequired,
  mappingActions: PropTypes.shape({
    setActiveDivision: PropTypes.func
  }).isRequired
};

MapColumns.defaultProps = {
  delimiter: ''
};

export default MapColumns;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/MapColumns.js